import React from 'react';
import { Accordion, AccordionSummary, AccordionDetails, Typography } from '@mui/material';
import { ExpandMore } from '@mui/icons-material';
import Lesson from '../Lesson';
import { ModuleContainer, moduleTitle } from './style';

function Module({ title, lessons, selectedLesson, callback, id }) {
  return (
    <Accordion
      defaultExpanded={lessons.some(lesson => lesson.id === selectedLesson.id)}
      sx={{ padding: '1.25rem 0' }}
      disableGutters
    >
      <AccordionSummary expandIcon={<ExpandMore />}>
        <Typography style={moduleTitle}>{title}</Typography>
      </AccordionSummary>
      <AccordionDetails>
        <ModuleContainer>
          {lessons.map(lesson => (
            <Lesson
              key={lesson.id}
              moduleId={id}
              lesson={lesson}
              isActive={lesson.id === selectedLesson.id}
              callback={callback}
            />
          ))}
        </ModuleContainer>
      </AccordionDetails>
    </Accordion>
  );
}

export default Module;
